module.exports = __webpack_public_path__ + "img/omelette-on.c798b879.svg";